import {
  NameIdTuple,
  RecycleBinViewDTO,
  RecycleClient,
  RestoreResponseDTO,
} from 'business/models/Models';
import BaseService from './BaseService';
import ModelFactory from 'business/models/ModelFactory';

export default class RecycleBinService extends BaseService {
  async GetRecycleBinView(): Promise<RecycleBinViewDTO[]> {
    const recycleBin: RecycleClient = ModelFactory(RecycleClient, false, true);
    const result = await recycleBin.getRecycleBinView();
    return result;
  }

  async DeleteNow(treeNodeIds: number[]): Promise<boolean> {
    const recycleBin: RecycleClient = ModelFactory(RecycleClient, false, true);
    const result = await recycleBin.deleteNow(treeNodeIds);
    return result;
  }

  async Restore(treeNodeIds: number[]): Promise<RestoreResponseDTO> {
    const recycleBin: RecycleClient = ModelFactory(RecycleClient, false, true);
    const result = await recycleBin.restore(treeNodeIds);
    return result;
  }

  async CheckDeleteDependencies(treeNodeIds: number[]): Promise<NameIdTuple[]> {
    const recycleBin: RecycleClient = ModelFactory(RecycleClient, false, true);
    const result = await recycleBin.checkDeleteDependencies(treeNodeIds);
    return result;
  }

  async CheckRestoreDependencies(treeNodeIds: number[]): Promise<NameIdTuple[]> {
    const recycleBin: RecycleClient = ModelFactory(RecycleClient, false, true);
    const result = await recycleBin.checkRestoreDependencies(treeNodeIds);
    return result;
  }
}
